import type { TypePolicies } from '../../../utils/types/TypePolicies';

/**
 * These types have no id, so Apollo stores them inside their parent. Without
 * merge: true, a query selecting fewer of their fields replaces them and drops
 * the fields other queries selected.
 */
export const typePolicies: TypePolicies = {
  AccountAppIntegrations: { merge: true },
  ExperienceManager: { merge: true },
  ExperienceManagerConfig: { merge: true },
  Workfront: { merge: true },
};
